import React, { CSSProperties } from 'react';
import { StackPanel, FlexBox, Typography } from '@agilepoint/wat-react-ux';
import { IconButton, ImageUploadField } from 'common';
import { useFormContext } from 'react-hook-form';
import { LogoTileWrapper, StyledImage } from '../styled-components';
import { useTranslate } from '@agilepoint/wat-react';
import { UploadImagesFormFields } from '../types';

interface IAppLogoTileProps {
    imageType: string;
    imageSize: string;
    imagePickerFieldName: string;
    resetImageURL: string;
    backgroundColor: CSSProperties;
}

export const AppLogoTile = (props: IAppLogoTileProps) => {
    const { imageSize, imageType, resetImageURL, imagePickerFieldName, backgroundColor } = props;
    const loadBackgroudColor = (imagePickerFieldName === UploadImagesFormFields.androidSplashScreenHDPIPortrait || imagePickerFieldName === UploadImagesFormFields.androidSplashScreenXXHDPIPortrait || imagePickerFieldName === UploadImagesFormFields.androidSplashScreenXHDPIPortrait)
        ? backgroundColor : {};
    const [imgURL, setImgURL] = React.useState(resetImageURL);
    const { watch, resetField } = useFormContext();
    const imageValue = watch(imagePickerFieldName);
    const translate = useTranslate();

    React.useEffect(() => {
        if (imageValue) {
            setImgURL(imageValue);
        }
    }, [imageValue]);

    const onUndoClick = React.useCallback(() => {
        setImgURL(resetImageURL);
        resetField(imagePickerFieldName, { keepDirty: false, defaultValue: resetImageURL });
    }, [imagePickerFieldName, resetField, resetImageURL]);

    return (
        <StackPanel gap="6" orientation='vertical'>
            <LogoTileWrapper orientation='vertical' alignment="center">
                <FlexBox justifyContent="space-between" width='100%'>
                    <IconButton iconName="maa-reset.outline" title={translate('common.actions.undo')} onClick={onUndoClick} />
                    <ImageUploadField
                        name={imagePickerFieldName}
                        accept='.jpg,.jpeg,.png'
                        gap="0"
                        title={translate('common.actions.uploadFile')} />
                </FlexBox>
                <FlexBox width="100%" height='calc(100% - 24px)' alignItems="center" justifyContent="center" style={loadBackgroudColor}>
                    <StyledImage src={imgURL} />
                </FlexBox>
            </LogoTileWrapper>
            <StackPanel orientation='vertical' alignment="center" width="100%">
                <Typography.Small title={imageType}>{imageType}</Typography.Small>
                <Typography.Small title={imageSize}>{imageSize}</Typography.Small>
            </StackPanel>
        </StackPanel>
    );
};
